import {useCallback, useRef, useState} from 'react';

/**
 * Implement a boolean toggle hook with toggle and setter mutators.
 * Returns a 4-tuple of [toggled, toggle, setTrue, setFalse]
 */
export function useToggle(defaultValue = false): [boolean, () => void, () => void, () => void] {
    const [toggled, setToggled] = useState(defaultValue);
    const toggle = useCallback(() => setToggled((t) => !t), []);
    const setTrue = useCallback(() => setToggled(true), []);
    const setFalse = useCallback(() => setToggled(false), []);
    return [toggled, toggle, setTrue, setFalse];
}

export function useOneWayToggle(initialValue = false): [boolean, () => void] {
    const ref = useRef(initialValue);
    const [toggled, setToggled] = useState(initialValue);
    const oneWay = useCallback(() => setToggled(!ref.current), []);
    return [toggled, oneWay];
}

export const usePermanentToggle = useOneWayToggle;
